import { Navigate, Outlet, useLocation } from "react-router-dom";
import { IsTokenExpired } from "../common/jwtToken";
import Layout from "../layout";

const ProtectedRoute = ({ children, ...rest }) => {
  const location = useLocation();
  const userPermissions = localStorage.getItem("permissions")?.split(',') || [];
  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  // console.log(userData,"userData")
  const isAdmin = userData?.adminOfSanstha?.[0]?.sanstha;
  //  console.log(userPermissions)
    const hubId = localStorage.getItem("hubId");
    const sansthaId = localStorage.getItem("sansthaId");
    const permissionOfHub = localStorage.getItem("permissionOfHub");
    const permissionOfSanstha = localStorage.getItem("permissionOfSanstha");

  if (!sansthaId && !permissionOfSanstha && userPermissions.length > 0) {
    // console.log("hiii1")
    return <Navigate to="/" />;
  }

  if (!localStorage.getItem("token")) {
    // console.log("hiii2")
    return <Navigate to="/" />
    // <Outlet />;
  }
    if (localStorage.getItem("token")) {
  // console.log("hii3")
    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  }
  const currentPath = location.pathname.substring(1);
  // console.log(currentPath)
  // If user is admin, allow access to all routes
  if (isAdmin) {
    // console.log("hiii4")
    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  }
  if (userPermissions && userPermissions.length > 0 && currentPath) {
    // console.log("hiii5")

    // if (currentPath === "dashboard") {
    //   return (
    //     <Layout>
    //       <Outlet />
    //     </Layout>
    //   );
    // }
    // Check if the current path starts with any of the user's permissions
    if (userPermissions.some(permission => currentPath.startsWith(permission))) {
    // console.log("hiii6")
      return (
        <Layout>
          <Outlet />
        </Layout>
      );
    }
    return <Navigate to={`/${userPermissions[0]}`} />;
  }
 // Default case: redirect to login
  return <Navigate to="/" />;
};

export default ProtectedRoute;


// import { Navigate, Outlet } from "react-router-dom";
// import Layout from "../layout";

// const ProtectedRoute = () => {
//   const token = localStorage.getItem("token");
//   const hubId = localStorage.getItem("hubId");

//   if (!token) {
//     return <Navigate to="/" replace />;
//   }
// if (token && hubId) {
//   return (
//     <Layout>
//       <Outlet />
//     </Layout>
//   );}
// };

// export default ProtectedRoute;


// import { Navigate, Outlet } from "react-router-dom";
// import Layout from "../layout";
// import { useEffect, useState } from "react";
// import Login from "../pages/login";

// const ProtectedRoute = () => {
//   const token = localStorage.getItem("token");
//   const hubId = localStorage.getItem("hubId")
// // console.log(token , "token")
//  if (token && hubId) {
//  console.log(token, "token")
//   return (
//     <Layout>
//       <Outlet />
//     </Layout>
//   );
// }
// //  if (!token) {
// //   console.log("!token")
// //     return <Navigate to="/" />;
// //   }
 
// // console.log(token , "token")
//  if (!token)  {
//   console.log(token)
//     return <Login />;
//   }

// };

// export default ProtectedRoute;

// import { Navigate, Outlet } from "react-router-dom";
// import Layout from "../layout";
// import { useEffect, useState } from "react";
// import Login from "../pages/login";

// const ProtectedRoute = () => {
//   const token = localStorage.getItem("token");
//   const hubId = localStorage.getItem("hubId");
  
//   if (token && !hubId) {
//     return <Login />;
//   }

//   if (token && hubId) {
//     return (
//       <Layout>
//         <Outlet />
//       </Layout>
//     );
//   }

//   // If either token or hubId is missing, show Login
//   return <Login />;
// };
// export default ProtectedRoute;
